import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Education from './components/Education';
import Projects from './components/Projects';
import Games from './components/Games';
import Blog from './components/Blog';
import Talks from './components/Talks';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

const PortfolioContent = ({ activeSection, setActiveSection }) => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to section when route changes
    const path = location.pathname.slice(1) || 'home';
    const sectionId = path === '' ? 'home' : path;
    
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setActiveSection(sectionId);
      }
    }, 100);
  }, [location.pathname, setActiveSection]);

  return (
    <>
      <Hero />
      <About />
      <Experience />
      <Education />
      <Blog />
      <Projects />
      <Talks />
      <Games />
      <Contact />
    </>
  );
};

function App() {
  const [activeSection, setActiveSection] = useState('home');

  return (
    <Router>
      <div className="App">
        <Header activeSection={activeSection} setActiveSection={setActiveSection} />
        <main>
          <Routes>
            <Route path="/" element={<PortfolioContent activeSection={activeSection} setActiveSection={setActiveSection} />} />
            <Route path="/about" element={<PortfolioContent activeSection={activeSection} setActiveSection={setActiveSection} />} />
            <Route path="/experience" element={<PortfolioContent activeSection={activeSection} setActiveSection={setActiveSection} />} />
            <Route path="/education" element={<PortfolioContent activeSection={activeSection} setActiveSection={setActiveSection} />} />
            <Route path="/blog" element={<PortfolioContent activeSection={activeSection} setActiveSection={setActiveSection} />} />
            <Route path="/projects" element={<PortfolioContent activeSection={activeSection} setActiveSection={setActiveSection} />} />
            <Route path="/talks" element={<PortfolioContent activeSection={activeSection} setActiveSection={setActiveSection} />} />
            <Route path="/games" element={<PortfolioContent activeSection={activeSection} setActiveSection={setActiveSection} />} />
            <Route path="/contact" element={<PortfolioContent activeSection={activeSection} setActiveSection={setActiveSection} />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

